(function(){
  function init(){document.querySelectorAll('[data-custom-showcase]').forEach(function(section){
    if(section.dataset.ready)return;section.dataset.ready='true';
    var hero=section.querySelector('[data-custom-hero]'),buttons=section.querySelectorAll('[data-custom-concept]');
    buttons.forEach(function(button){button.addEventListener('click',function(){
      hero.src=button.dataset.image;hero.alt=button.dataset.label+' custom fairing design concept';
      buttons.forEach(function(other){other.setAttribute('aria-pressed',String(other===button));});
      section.querySelector('[data-custom-status]').textContent=button.dataset.label+' design concept selected.';
    });});
  });}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();
